import * as React from 'react'

import * as Sentry from '@sentry/react'
import { captureExceptionWithSentry } from './sentry'

interface ErrorState {
	hasError: boolean
	eventId?: string
}

export class ErrorBoundary extends React.Component<{}, ErrorState> {
	constructor(props: {}) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(_error: Error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true }
	}

	public componentDidCatch(error: Error, errorInfo: any) {
		Sentry.withScope((scope) => {
			scope.setExtras(errorInfo)
			const eventId = captureExceptionWithSentry(error)
			this.setState({ eventId })
		})
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div style={{ textAlign: 'center' }}>
					<h1>Sorry.</h1>
					<p>Something went wrong. Please reload (Ctrl or Shift + refresh) the page to continue.</p>
					<p>If the error persists, please report to Readpeak. Event id {this.state.eventId}</p>
					<button onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>
						Report feedback
					</button>
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
